
import { defineComponent } from 'vue-demi'

export default defineComponent({
    props: {
        imageFileName: {
            type: String,
            default: 'img_item_01.jpg',
        },
        altText: {
            type: String,
            default: 'Imagem',
        },
        title: {
            type: String,
            default: 'Liquidez',
        },
        description: {
            type: String,
            default: 'Descrição',
        },
    },
})
